export const PRYSM_APP_CENTRAL_ID = '8871f9d0-71ca-451d-9e8b-ff4692404e6e';
